export const GET_CURRENT_EDOK_YEAR_FAILURE = 'GET_CURRENT_EDOK_YEAR_FAILURE';

export const getCurrentEdokYearFailure = error => ({
    type: GET_CURRENT_EDOK_YEAR_FAILURE,
    payload: error,
    error: true,
});
